module.exports = __webpack_public_path__ + "static/media/find_dc2.5d1e19c4.ico";